import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Container = styled(motion.div)`
  width: 5rem;
  height: 5rem;
  border: 5px solid transparent;
  border-top: 5px solid #fff;
  border-radius: 50%;
`;
